type BrandMarkProps = {
  inverse?: boolean;
};
const darkSurfaceLogo = 'https://cdn.magicpatterns.com/uploads/2RVn5KHVgSnSgoxVeZvnwH/ai_Credit_Manager_final-03.png';
const lightSurfaceLogo = 'https://cdn.magicpatterns.com/uploads/fBFtM9sLVmxujUhp4EoFeB/ai_Credit_Manager_final-12.png';
export function BrandMark({
  inverse = false
}: BrandMarkProps) {
  return <span role="img" aria-label="Credit Manager" className="relative block h-8 w-44 overflow-hidden" data-id="element-57" data-mp="olsntxnt22sx">
      <img src={inverse ? darkSurfaceLogo : lightSurfaceLogo} alt="" className={`absolute -left-[21px] -top-[33px] h-24 max-w-none object-contain ${inverse ? 'mix-blend-screen' : ''}`} data-id="element-58" data-mp="1m9u9ubw6954m" />
    </span>;
}